import { createAction } from 'typesafe-actions'
import { RegisterVideosAction, TutoActionTypes } from './types'

export const registerVideos = createAction(TutoActionTypes.REGISTER_VIDEOS)<RegisterVideosAction>()
